// https://webpack.js.org/guides/dependency-management/#context-module-api
const cache: Dictionary<string> = {};
const request = require.context('../components/', true, /index\.ts$/);
request.keys().forEach((key) => (cache[key] = request(key)));
